export const environment = {
  production: false,
  apiUrl: 'https://devapi.technikflg.com/v1/',
  wsUrl: 'https://devapi.technikflg.com/',
};
